import React from 'react';
import { t } from 'i18next';
import PropTypes from 'prop-types';
import { ModalBody, ModalTitle, ButtonDiv } from '../css';
import { contacts } from '../../../utils/constants';

import PrimaryButton from '../../../lib/ui/buttons/PrimaryButton';
import SecondaryButton from '../../../lib/ui/buttons/SecondaryButton';

const CreateShipmentModals = (props) => {
  const {
    handleModalButtons,
    closeModal,
    cancelShipmentRequest,
    errorMessage,
    embargoErrorMessage,
    isManageContactPermission,
    cancelShipment,
    cancelShipmentWarning,
    cancelShipmentSuccess,
    isAuthenticated,
    fields,
    createShipmentFlag,
  } = props;

  return (
    <ModalBody>

      <ModalTitle>
        {embargoErrorMessage
          ? t('Alert')
          : isManageContactPermission
            ? t(fields.ManageContactPermissionTitle.value)
            : (errorMessage && cancelShipment && !cancelShipmentWarning)
              ? t('CancelShipment')
              : (errorMessage && cancelShipment && cancelShipmentWarning)
                ? t('CancelShipmentWarning')
                : t('Error')}
      </ModalTitle>

      {errorMessage && cancelShipment && !cancelShipmentWarning ? (
        <p>{errorMessage}</p>
      ) : (createShipmentFlag && (errorMessage === t('ErrorMessage')))
        ? (
          <>
            <p><strong>{errorMessage}</strong></p>
            <p>{t('PleaseContactSupportHotline')}</p>
          </>
        )
        : (
          <>
            <p><strong>{errorMessage}</strong></p>
            <p>{(isManageContactPermission || embargoErrorMessage) ? t('') : t('PleaseContactCustomerService')}</p>
            <p>{(errorMessage || (cancelShipment && !isAuthenticated)) ? contacts.LTLCustomerNumber : t('')}</p>
            <p>{(errorMessage || (cancelShipment && !isAuthenticated)) ? contacts.CommerceCustomerNumber : t('')}</p>
          </>
        )}

      <ButtonDiv className="row no-gutters">
        {
                embargoErrorMessage ? (
                  <div className="col-sm-12">
                    <SecondaryButton
                      name="returnToStepTwo"
                      label={t('Okay')}
                      onClick={(e) => handleModalButtons(e)}
                    />
                  </div>
                ) : (isManageContactPermission) ? (
                  <div className="col-sm-12">
                    <SecondaryButton
                      name="okay"
                      label={t('Okay')}
                      onClick={(e) => handleModalButtons(e)}
                    />
                  </div>
                ) : (errorMessage && cancelShipment && !cancelShipmentWarning && !cancelShipmentSuccess) ? (
                  <>
                    <div className="col-sm-12 col-md">
                      <SecondaryButton
                        label={t('GoBack')}
                        onClick={() => closeModal()}
                        showArrow={false}
                      />
                    </div>
                    <div className="col-sm-12 col-md">
                      <PrimaryButton
                        name="cancelButton"
                        label={t('CancelShipment')}
                        onClick={() => cancelShipmentRequest()}
                      />
                    </div>
                  </>
                ) : (errorMessage && cancelShipment && (cancelShipmentWarning || cancelShipmentSuccess)) ? (
                  <div className="col-sm-12">
                    <PrimaryButton
                      name="closeModal"
                      label={t('Close')}
                      onClick={() => closeModal()}
                    />
                  </div>
                ) : (errorMessage && !cancelShipment) ? (
                  <div className="col-sm-12">
                    <SecondaryButton
                      name="acceptErrorMessage"
                      label={t('Accept')}
                      onClick={(e) => handleModalButtons(e)}
                    />
                  </div>
                ) : (
                  <>
                    <div className="col-sm-12 col-md">
                      <PrimaryButton
                        name="cancelButton"
                        label={t('ReturnToShipment')}
                        onClick={(e) => handleModalButtons(e)}
                      />
                    </div>
                    <div className="col-sm-12 col-md">
                      <SecondaryButton
                        name="createNewQuote"
                        label={t('CreateaNewQuote')}
                        onClick={(e) => handleModalButtons(e, 'createNewQuote')}
                      />
                    </div>
                  </>
                )
              }
      </ButtonDiv>

    </ModalBody>
  );
};

CreateShipmentModals.propTypes = {
  handleModalButtons: PropTypes.func,
  closeModal: PropTypes.func,
  cancelShipmentRequest: PropTypes.func,
  errorMessage: PropTypes.string,
  embargoErrorMessage: PropTypes.bool,
  isManageContactPermission: PropTypes.bool,
  cancelShipment: PropTypes.bool,
  cancelShipmentWarning: PropTypes.bool,
  cancelShipmentSuccess: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  fields: PropTypes.object,
  createShipmentFlag: PropTypes.bool,
};

export default CreateShipmentModals;
